import { useTranslation } from "react-i18next";
import { Activity, User } from "../types";
import { chat } from "@microsoft/teams-js";

export function SenderReceiverText({ activity }: { activity: Activity }) {
  const { t } = useTranslation();

  function openUserChat(user: User) {
    if(user.user_principal_name) {
      chat.openChat({user: user.user_principal_name});
    }
  }

  return (
    <p>
      <button className="btn-user" onClick={() => openUserChat(activity.sender)}>
        <span>{activity.sender.firstname} {activity.sender.lastname}</span>
      </button>
      <span> { activity.is_bonus ? t('has_sent_a_bonus_of') : t('has_sent') } {activity.points} {activity.currency} {t('to')} </span>
      <button className="btn-user" onClick={() => openUserChat(activity.receiver)}>
        <span>{activity.receiver.firstname} {activity.receiver.lastname}</span>
      </button>
    </p>
  )
}
